export default "__VITE_ASSET__73c82ca4__"